import { useEffect, useState, PropsWithChildren } from "react";
import { useTranslation, I18nextProvider } from "react-i18next";

import { CustomObject } from "./types/";

import en_US from "./locales/en_US.json";
import pt_BR from "./locales/pt_BR.json";
import es from "./locales/es.json";

const I18n = ({
    children,
}: PropsWithChildren<CustomObject>): JSX.Element | null => {
    const [bootstrapping, setBootstrapping] = useState(true);

    const { i18n } = useTranslation();

    useEffect(() => {
        i18n.addResourceBundle("en_US", "translation", en_US, true, true);
        i18n.addResourceBundle("pt_BR", "translation", pt_BR, true, true);
        i18n.addResourceBundle("es", "translation", es, true, true);

        setBootstrapping(false);
    }, [i18n]);

    if (bootstrapping) {
        return null;
    }

    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18n;
